import React, { createContext, useState, useContext, useCallback } from 'react';
import Toast from './Toast';

// 1. Create the context to hold our toast functions
const ToastContext = createContext();

// 2. Create a custom hook to make it easy to use the context
export const useToast = () => {
    return useContext(ToastContext);
};

// 3. Create the provider component
export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    // useCallback ensures this function isn't recreated on every render
    const addToast = useCallback((message, type = 'info') => {
        // Combine Date.now() with a random number for a more unique ID
        const id = `${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
        // Add new toast to the array
        setToasts(prevToasts => [...prevToasts, { id, message, type }]);

        // Set a timeout to remove the toast after 5 seconds
        setTimeout(() => {
            removeToast(id);
        }, 5000);
    }, []);

    const removeToast = (id) => {
        setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
    };

    // The value provided to children components
    const value = {
        addToast,
    };

    return (
        <ToastContext.Provider value={value}>
            {children}

            {/* This is the container that will display the toasts */}
            <div className="fixed top-5 right-5 z-50 space-y-3 w-full max-w-sm">
                {toasts.map(toast => (
                    <Toast key={toast.id} message={toast.message} type={toast.type} />
                ))}
            </div>
        </ToastContext.Provider>
    );
};